// extracted by mini-css-extract-plugin
export default {"ghostCardContainer":"Home_ghostCardContainer__XsJ0+","ghostCardText":"Home_ghostCardText__OxLkv","ghostCardImg":"Home_ghostCardImg__2j5Gu","feedDiv":"Home_feedDiv__uQCSM"};